module.exports = __webpack_public_path__ + "img/iphone_start.2a207a0c.png";